import gql from "graphql-tag";

export const templateActivityFragment = gql`
  fragment TemplateActivityFragment on TemplateActivity {
    id
    name
    rank
    description
    estimation
    priority
    activityType
    dependingOn {
      id
      name
    }
    blocking {
      id
      name
    }
  }
`;

export const activityFragment = gql`
  fragment ActivityFragment on Activity {
    id
    name
    rank
    description
    estimation
    priority
    blocked
    active
    slug
    assignee {
      id
      firstName
      lastName
      avatarUrl
    }
    milestone {
      id
      name
      color
      phase {
        id
        name
      }
    }
    project {
      id
      name
      color
      estimationUnit
      phases {
        id
        milestones {
          id
          name
        }
      }
    }
    activityType
    devStatus {
      id
      name
      rank
    }
    sprint {
      id
      number
      label
      projectId
      startDate
      endDate
    }
    status {
      id
      name
    }
    blocking {
      id
    }
    dependingOn {
      id
    }
    deadline
    private
    createdAt
    createdBy {
      id
      firstName
      lastName
      avatarUrl
    }
  }
`;

export const attachmentFragment = gql`
  fragment AttachmentFragment on Attachment {
    id
    fileId
    name
    size
    mimeType
    url
  }
`;
